import React, { Component } from 'react';
import { Col, Form, FormControl, FormGroup, Button, Modal } from 'react-bootstrap';
import rest from 'rest';

import Status from '../Helper/Status';

/**
* Class Geom
* Geom form
**/
class Geom extends Component {

  /**
  * constructor
  * Init state
  **/
  constructor(props) {
    super(props);

    this.state = {
      object: this.props.object,
      opened: this.props.opened === true,
      status: {}
    };
  }

  /**
  * render
  * Render the component : modal with form
  **/
  render() {
    // Form status information
    const status = <Status parent={this} type={this.state.status.type} message={this.state.status.message} />;

    return(
      <Modal show={this.state.opened === true} onHide={this.handleCancel.bind(this)}>
        <Modal.Header closeButton>
          <Modal.Title>Libellé de la géométrie</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* Status information */}
          {status}
          <Form horizontal>
            <FormGroup>
              <Col sm={8}><FormControl id="libelle" type="text" placeholder="Entrez un nouveau libellé" value={this.state.object.libelle} onChange={this.handleChange.bind(this)} /></Col>
              <Col sm={1}>
                <Button bsStyle="success" onClick={this.handleSave.bind(this)}>Valider</Button>
              </Col>
            </FormGroup>
          </Form>
        </Modal.Body>
      </Modal>
    );
  }

  /**
  * handleChange
  * Modify the state from a field change
  **/
  handleChange(e) {
    let objState = this.state;
    objState.object[e.target.id] = e.target.value;
    this.setState(objState);
  }

  /**
  * handleCancel
  * Close the modal
  **/
  handleCancel() {
    this.setState({opened: false});
  }

  /**
  * handleSave
  * Save and close the modal
  **/
  handleSave() {
    const geomObj = this.state.object;

    rest({
      method: "PUT",
      path: this.props.path,
      entity: JSON.stringify(geomObj),
      headers: {
  			'Content-Type': 'application/json'
  		}
    }).then(response => {
      if(response.status.code === 200) {
        this.setState({
          opened: false
        });

        this.props.parentGrid.reload();
      } else {
        this.setState({
          status: {
            type: 'danger',
            message: 'Erreur de sauvegarde.'
          }
        });
      }
  	}, response => {
      this.setState({
        status: {
          type: 'danger',
          message: 'Problème d\'appel au serveur.'
        }
      });
		});
  }

}
export default Geom;



// WEBPACK FOOTER //
// ./src/views/Entity/Geom.js